export const AudioSharingVersion = {
	V1: '1',
} as const;

export type AudioSharingVersionType = (typeof AudioSharingVersion)[keyof typeof AudioSharingVersion];
